import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, ShoppingCart, Package, Users, Crown, Shield, BarChart3, LogOut, MessageCircle } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const NAV = [
  { to: "/admin/dashboard", icon: LayoutDashboard, label: "Dashboard" },
  { to: "/admin/orders", icon: ShoppingCart, label: "Orders" },
  { to: "/admin/products", icon: Package, label: "Products" },
  { to: "/admin/customers", icon: Users, label: "Customers" },
  { to: "/admin/legacy", icon: Crown, label: "Legacy Requests" },
  { to: "/admin/authenticity", icon: Shield, label: "Authenticity" },
  { to: "/admin/concierge", icon: MessageCircle, label: "Concierge" },
  { to: "/admin/analytics", icon: BarChart3, label: "Analytics" },
];

export default function AdminShell() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div data-testid="admin-shell" className="min-h-screen bg-poche-black text-white grid grid-cols-1 md:grid-cols-[260px_1fr]">
      <aside className="border-r border-white/10 bg-poche-black px-5 py-7 sticky top-0 h-screen flex flex-col">
        <Link to="/admin/dashboard" className="font-serif text-2xl text-poche-gold tracking-luxury">POCHE</Link>
        <div className="text-[10px] tracking-luxury uppercase text-white/45 mt-1">Atelier Admin</div>
        <nav className="mt-10 flex-1 space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 text-[11px] tracking-luxury uppercase transition-colors ${isActive ? "bg-poche-gold/10 text-poche-gold border-l-2 border-poche-gold" : "text-white/65 hover:text-poche-gold border-l-2 border-transparent"}`}
            >
              <n.icon size={15} strokeWidth={1.4} />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-white/10 pt-4 mt-4">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 bg-poche-gold rounded-full flex items-center justify-center text-poche-black font-serif">
              {user?.name?.charAt(0) || "A"}
            </div>
            <div className="flex-1 truncate">
              <div className="text-xs">{user?.name}</div>
              <div className="text-[10px] tracking-luxury uppercase text-white/45 truncate">{user?.email}</div>
            </div>
          </div>
          <button data-testid="admin-logout" onClick={async () => { await logout(); navigate("/admin/login"); }} className="mt-3 w-full text-[10px] tracking-luxury uppercase text-white/55 hover:text-poche-gold flex items-center gap-2 justify-center py-2 border border-white/10">
            <LogOut size={12} /> Sign Out
          </button>
        </div>
      </aside>

      <main className="overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
